import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-grow: 1;
`
